<template>

    <v-modal title="Discord" :loading="starting">

        <template #body v-if="!integration">
            <v-notice type="danger" size="sm" :message="$t('action.connect')" />
        </template>

        <template #body v-else>
            <v-alert :message="error" />
            <v-form-group dir="ver" label="Message">
                <v-textarea-variable :model="params.body" @input="params.body = $event" />
            </v-form-group>
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button v-if="integration" size="sm" :loading="loading" @click.native="saveAction">Save</v-button>
            <v-button v-else size="sm" :loading="loading" @click.native="connectAction">Connect Integration</v-button>
        </template>

    </v-modal>

</template>

<script>

import ModalActionMixin from '@mixins/ModalActionMixin';

export default {

    mixins: [ModalActionMixin],

    data() {
        return {
            params: {
                type: this.action.type,
                body: this.action.body,
            },
        }
    },

    mounted() {
        this.getIntegration(this.action.type);
    },

}

</script>
